<script>
import { mapActions, mapState } from 'pinia';
import { useCommentStore } from '../../../store/useCommentStore.js';

export default {
  name: 'CpShowInteractionsCount',
  props: {
    type: String,
    id: [Number, String],
    likesCount: Number,
    endorsesCount: Number,
    opposesCount: Number,
    commentsCount: Number,
    handleLikesModal: Function,
    handleEndorsesModal: Function,
    handleOpposesModal: Function,
  },
  computed: {
    ...mapState(useCommentStore, ['areCommentsDisplayed']),
  },
  methods: {
    ...mapActions(useCommentStore, ['handleDisplayComments']),
  },
};
</script>
<template>
  <div>
    <span v-if="likesCount > 0" class="body1 primary-blue-400-color cursor-pointer" @click="handleLikesModal">
        {{ likesCount }}
        {{ likesCount == 1 ? 'Like' : 'Likes' }}
    </span>
    <span v-if="endorsesCount > 0" class="body1 primary-blue-400-color cursor-pointer" @click="handleEndorsesModal">
      {{ endorsesCount }}
      {{ endorsesCount == 1 ? 'Endorse' : 'Endorses' }}
    </span>
    <span v-if="opposesCount > 0" class="body1 primary-blue-400-color cursor-pointer" @click="handleOpposesModal">
      {{ opposesCount }}
      {{ opposesCount == 1 ? 'Oppose' : 'Opposes' }}
    </span>
    <span v-if="commentsCount > 0" class="body1 primary-blue-400-color cursor-pointer comments-count" @click="handleDisplayComments({type, id})">
      {{areCommentsDisplayed[`${type}-${id}`] ?? true ? 'Hide Comments' : 'Show Comments'}}
    </span>
  </div>
</template>
<style scoped>
.cursor-pointer {
  cursor: pointer;
}
.comments-count {
  float: right;
}
</style>
